import { getCurrentUser } from '@/lib/auth-utils'
import { ROLE_ADMIN } from '@/lib/permissions'
import { neon } from '@/services/neon'

export async function fetchAccessibleCompanyIds(userId: string): Promise<string[]> {
  const [ownedRes, memberRes] = await Promise.all([
    neon.from('companies').select('id').eq('owner', userId),
    neon
      .from('company_members')
      .select('company_id,role')
      .eq('user_id', userId)
      .eq('is_active', true),
  ])

  const ids = new Set<string>()
  ;((ownedRes.data as Array<{ id: string }> | null) || []).forEach((row) => {
    ids.add(row.id)
  })
  ;((memberRes.data as Array<{ company_id?: string; role?: string }> | null) || []).forEach(
    (row) => {
      if (row.company_id && (row.role === 'owner' || row.role === 'manager')) {
        ids.add(row.company_id)
      }
    },
  )

  return Array.from(ids)
}

export async function checkPropertyAccess(propertyId: string, action: string): Promise<string> {
  const { data: property } = await neon
    .from('properties')
    .select('company_id')
    .eq('id', propertyId)
    .single()
  const companyId = (property as { company_id: string } | null)?.company_id
  if (!companyId) throw new Error('Property not found.')

  const user = getCurrentUser()
  if (!user?.id) throw new Error('User not authenticated.')

  if (user.role !== ROLE_ADMIN) {
    const companyIds = await fetchAccessibleCompanyIds(user.id)
    if (!companyIds.includes(companyId)) {
      throw new Error(`You do not have permission to ${action} on this property.`)
    }
  }

  return companyId
}
